// extracted by mini-css-extract-plugin
export default {"switch":"checkbox_switch__g4mxf","slider":"checkbox_slider__MPiND","circle":"checkbox_circle__ChZ4X","on":"checkbox_on__2HqRE"};